import { Alert, Box, Snackbar, styled, Typography } from '@mui/material'
import type { FC } from 'react'

import { Z_INDEX, unit } from '@hcr/ui'

interface InfoMessageFloatingProps {
  isOpen?: boolean
  message: string
  onClose?: () => void
  variant?: 'success' | 'error'
}

export const InfoMessageFloating: FC<InfoMessageFloatingProps> = ({
  onClose,
  message,
  variant,
  isOpen,
}: InfoMessageFloatingProps) => {
  return (
    <Container>
      <Content>
        <Snackbar
          autoHideDuration={3000}
          open={isOpen}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          sx={{ position: 'static', width: '100%' }}
          onClose={onClose}
        >
          <Alert severity={variant} title={message} onClose={onClose} sx={{ width: '100%' }}>
            <Typography variant='labelM'>{message}</Typography>
          </Alert>
        </Snackbar>
      </Content>
    </Container>
  )
}

const Container = styled(Box)`
  position: sticky;
  bottom: ${unit(4)};
  z-index: ${Z_INDEX.toast};
`

const Content = styled(Box)`
  position: absolute;
  bottom: 0;
  left: ${unit(2)};
  right: ${unit(2)};
`
